var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256z",
    fill: "#471700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 202.9c3.3 73.9-51.8 156.2-149.3 156.2-29.7 0-57.3-8.7-80.5-23.6 27.9 3.3 55.7-4.4 77.8-21.7-23-.4-42.4-15.6-49.1-36.5 8.2 1.6 16.3 1.1 23.7-.9-25.3-5.1-42.7-27.8-42.1-52.2 7.1 3.9 15.2 6.3 23.8 6.6-23.4-15.6-30-46.5-16.3-70.1 25.9 31.8 64.6 52.7 108.3 54.9-7.6-32.9 17.3-64.5 51.2-64.5 15.1 0 28.7 6.4 38.3 16.6 12-2.4 23.2-6.7 33.4-12.7-3.9 12.3-12.3 22.6-23.1 29.1 10.6-1.3 20.7-4.1 30.2-8.3-7.2 10.5-16.1 19.7-26.3 27.1z",
    fill: "#FFF"
  })));
}

export default SvgTwitter;